/**
 * Checks if object has same values among different keys
 * @param obj Object for checking if same values exist among different keys
 * @returns `true` if object has keys with same values, otherwise it returns `false`
 */
export const hasDuplicateValues = (obj: Record<string, string>): boolean => {
  const seenValues: Record<string, boolean> = {};
  for (const key of Object.keys(obj)) {
    const value = obj[key];
    if (seenValues[value]) {
      return true;
    }
    seenValues[value] = true;
  }

  return false;
};
